<template>
  <div class="content" v-if="showHelp">
    <div
      :class="[{ overlay: showMenu || !showDropDown }]"
      @click="closeAll()"
    ></div>
    <button class="button" @click="openHideMenu()">
      <span @click="hideHelp()">
        <i class="material-icons close">
          close
        </i>
      </span>
      <span class="p-5px">Help</span>
      <i class="material-icons help">
        help
      </i>
      <div v-if="showMenu == true && showDropDown" class="drop-down">
        <ul class="lists">
          <li class="p-5px" @click="showVideoPopup()">See how it works</li>
          <li class="p-5px" @click="showFeedbackPopup()">Feedback</li>
          <li class="p-5px" @click="redirectTosupport()">Contact support</li>
        </ul>
      </div>
    </button>
    <Demo-Video
      v-if="showHelp && !showDropDown && showDemoVideo"
      v-on:close="closeAll()"
    />
    <Feedback-Form
      v-if="showHelp && !showDropDown && showFeedbackForm"
      v-on:close="closeAll()"
    />
  </div>
</template>

<script>
import demoVideo from '@/components/help/DemoVideoPopup.vue'
import feedbackForm from '@/components/help/FeedbackFormPopup.vue'
import sharedFunction from './../../assets/util/functions.js'

export default {
  name: 'Help-Menu',
  data: function() {
    return {
      showMenu: false,
      showHelp: true,
      showDemoVideo: false,
      showFeedbackForm: false,
      showContactSupport: false,
      showDropDown: true
    }
  },
  components: {
    'Demo-Video': demoVideo,
    'Feedback-Form': feedbackForm
  },
  methods: {
    openHideMenu() {
      this.showMenu = !this.showMenu
      sharedFunction.track(
        'AP - Help button clicked',
        { openMenu: this.showMenu },
        this.$store.state
      )
    },
    closeAll() {
      this.showMenu = false
      this.showDropDown = true
      this.showDemoVideo = false
      this.showFeedbackForm = false
      this.showContactSupport = false
    },
    showVideoPopup() {
      sharedFunction.track(
        'AP - See how it works Clicked',
        null,
        this.$store.state
      )
      this.showDropDown = false
      this.showDemoVideo = true
    },
    showFeedbackPopup() {
      sharedFunction.track(
        'AP - Product Feedback Click',
        null,
        this.$store.state
      )
      this.showDropDown = false
      this.showFeedbackForm = true
    },
    redirectTosupport() {
      sharedFunction.track(
        'AP - Contact Support Clicked',
        null,
        this.$store.state
      )
      this.closeAll()
      setTimeout(() => {
        window.open('https://www.adapt.io/contact-us/', '_blank')
      }, 1000)
    },
    hideHelp() {
      this.showHelp = false
      sharedFunction.track('AP - Close Help Clicked', null, this.$store.state)
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  position: relative;
  .button {
    position: fixed;
    bottom: 45px;
    right: 20px;
    padding: 2px 10px;
    background: rgba(8, 8, 8, 0.61);
    color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    z-index: 9;
    border: 1px solid #dcdcdc;
    width: 80px;
    .close {
      font-size: 9px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.1s ease;
      &:hover {
        font-size: 11px;
        transition: all 0.1s ease;
        background: #3c3c3c;
        color: $white;
      }
    }
    .help {
      font-size: 14px;
      vertical-align: middle;
      color: $white;
    }
    .drop-down {
      width: 140px;
      z-index: 1;
      background: $white;
      border: 1px solid $white;
      position: absolute;
      bottom: 30px;
      right: 50px;
      color: $black;
      border-radius: 5px;
      .lists {
        list-style-type: none;
        text-align: left;
        padding: 5px;
        margin: 0;
        li:hover {
          background: #e9ecec;
          border-radius: 3px;
        }
      }
    }
  }
}
.overlay {
  background: rgba(0, 0, 0, 0.68);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  transition: all 0.3s ease;
}
</style>
